import { CommonComponent } from "@/components/types";
import { Heading, Paragraph, ParagraphProps } from "@cgc/ui/typography";
import { PrismicLink } from "@prismicio/react";
import React from "react";

export const defaultComponents = {
  heading1: ({ children }: CommonComponent) => (
    <Heading display className="text-2xl font-black uppercase">
      {children}
    </Heading>
  ),
};

export const thinComponents = {
  heading1: ({ children }: CommonComponent) => (
    <Heading
      display
      className="text-cgc-white m-0 mt-1 px-5 uppercase leading-8"
    >
      {children}
    </Heading>
  ),
};

const ResponsiveParagraph: React.FC<ParagraphProps> = (props) => (
  <>
    <Paragraph {...props} size="sub2" mobileOnly />
    <Paragraph {...props} size="sub" desktopOnly />
  </>
);

export const dualColumnComponents = {
  heading1: ({ children }: CommonComponent) => (
    <Heading display centered className="my-0 text-white">
      {children}
    </Heading>
  ),
  heading2: ({ children }: CommonComponent) => (
    <Heading.h2 display centered className="my-0 text-white">
      {children}
    </Heading.h2>
  ),
  heading3: ({ children }: CommonComponent) => (
    <Heading.h3 display centered className="my-0 text-white">
      {children}
    </Heading.h3>
  ),
  paragraph: ({ children }: CommonComponent) => (
    <ResponsiveParagraph className="text-center text-white">
      {children}
    </ResponsiveParagraph>
  ),
  hyperlink: ({ node, children, key }) => {
    return (
      <PrismicLink
        key={key}
        field={node.data}
        className="text-white hover:text-white"
      >
        {children}
      </PrismicLink>
    );
  },
};

export const buttonsActionCopyComponents = {
  paragraph: ({ children }: CommonComponent) => (
    <Paragraph className="text-center text-white">{children}</Paragraph>
  ),
  hyperlink: ({ node, children, key }) => {
    return (
      <PrismicLink
        key={key}
        field={node.data}
        className="text-white hover:text-white"
      >
        {children}
      </PrismicLink>
    );
  },
};

const BenefitsParagraph: React.FC<ParagraphProps> = (props) => (
  <>
    <Paragraph {...props} size="p3" mobileOnly />
    <Paragraph {...props} size="p2" desktopOnly />
  </>
);

export const benefitsCopyComponents = {
  paragraph: ({ children }: CommonComponent) => (
    <BenefitsParagraph className="text-cgc-blue text-center">
      {children}
    </BenefitsParagraph>
  ),
};
